const wowApp = require('angular').module('wowApp.common');

wowApp.service('BreakpointsService', ['$rootScope', require('./breakpoints.service')]);

wowApp.service('BrowserWindowService', ['$rootScope', 'BreakpointsService', require('./browserwindow.service')]);

wowApp.run(['$rootScope', 'BrowserWindowService', 'BreakpointsService', ($rootScope, browserWindowService, breakpointsService) => {
    browserWindowService.init();

    // While this is a bit dodgy to have globally, it will save
    // mountains of boilerplate injecting this service just to use
    // it in templates.
    $rootScope.$breakpoints = breakpointsService;
}]);



// WEBPACK FOOTER //
// ./src/common/breakpoints/index.js